import { Spin } from 'antd';
import { Component } from 'react';

import NoFactorProductImg from '../../../assets/images/base/invoice.png';
import { BaseURL, test } from '../../../base/env';
import { TComma, formatNumberWithCurrency } from '../../../base/utils';
import { Note, Page, Uniter } from '../../../helbest';
import { API } from '../../../request/api';

export default class Orders_Detail extends Component {
  constructor({ match }) {
    super({ match });
    this.state = {
      loading: true,
      orders_detail: [],
      id: match.params.id,
      noFactorProducts: []
    };
  }

  componentDidMount() {
    this.__get_orders_detail();
    this.get_no_factor_products();
  }

  __get_orders_detail() {
    const { match } = this.props;
    API.get
      .userOrders(match.params.id)
      .then((response) => {
        if (response.success) {
          this.setState({ orders_detail: response.data, loading: false });
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  }

  get_no_factor_products() {
    API.get
      .config('no_factor_products')
      .then((response) => {
        if (response.success) {
          this.setState({ noFactorProducts: response.data.no_factor_products.product_id });
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  }

  render() {
    const { loading } = this.state;
    const { orders_detail, noFactorProducts } = this.state;
    const orderLineProductIds = orders_detail?.order_lines?.map((order) => order.product.id) || [];
    const hasNoFactorProduct = orderLineProductIds.some((productId) =>
      noFactorProducts.includes(productId)
    );

    return (
      <Page
        address="/orders/"
        back={true}
        className="page-profile"
        headerFix
        mobileContainer
        showFooter
        title="جزئیات سفارش">
        <div className="factors-holder factors-scroll hei-100p page-factor-factors-container">
          {loading ? (
            <div className="text-center mt-5">
              <Spin size="large" />
            </div>
          ) : (
            <div>
              <div className="factors-item page-factor-factors-item">
                {hasNoFactorProduct ? (
                  <div className="no-factor-product-item">
                    <img alt="no-factor-product" height="100%" src={NoFactorProductImg} />
                  </div>
                ) : null}
                <div className="orders-detail-info">
                  <div className="w-100">
                    <label>سفارش {orders_detail.id}</label>
                    <span>
                      <span className="pa-l-5"> {orders_detail.time} </span>
                      <span> {orders_detail.date} </span>
                    </span>
                  </div>
                  {!hasNoFactorProduct ? (
                    <div className="w-100">
                      <label>وضعیت</label>
                      <span>{orders_detail.delivery_status}</span>
                    </div>
                  ) : null}
                  {!hasNoFactorProduct ? (
                    <div className="w-100">
                      <label>شناسه پرداخت</label>
                      <span>
                        {orders_detail.cash_payment
                          ? 'پرداخت در محل'
                          : orders_detail.reference_id || '-'}
                      </span>
                    </div>
                  ) : null}
                  <div className="w-100">
                    <label>کد پستی</label>
                    <span>{orders_detail.address.zip_code}</span>
                  </div>
                  <div className="w-100">
                    <span>
                      {orders_detail.address.province} - {orders_detail.address.city} -{' '}
                      {orders_detail.address.region} - {orders_detail.address.address}
                    </span>
                  </div>
                  <hr />
                  <div className="w-100">
                    <label>جمع کل</label>
                    {orders_detail.amount === '-' ? (
                      ''
                    ) : (
                      <Uniter className="orders-toman-price" unit="تومان">
                        {orders_detail.amount}
                      </Uniter>
                    )}
                  </div>
                  <div className="w-100">
                    <label>هزینه ارسال</label>
                    {orders_detail.amount === '-' ? (
                      ''
                    ) : (
                      <Uniter className="orders-toman-price" unit="تومان">
                        {orders_detail.delivery_amount}
                      </Uniter>
                    )}
                  </div>
                  {orders_detail.discount_amount ? (
                    <div className="w-100">
                      <label>
                        کد تخفیف
                        {orders_detail.discount_code !== '-'
                          ? ` (${orders_detail.discount_code})`
                          : null}
                      </label>
                      {orders_detail.amount === '-' ? (
                        ''
                      ) : (
                        <Uniter className="orders-toman-price" unit="تومان">
                          {orders_detail.discount_amount}
                        </Uniter>
                      )}
                    </div>
                  ) : null}
                  {orders_detail.credit_amount && !hasNoFactorProduct ? (
                    <div className="w-100">
                      <label>اعتبار کیف پول</label>
                      {orders_detail.amount === '-' ? (
                        ''
                      ) : (
                        <span className="orders-toman-price">
                          {formatNumberWithCurrency(TComma(orders_detail.credit_amount))}
                        </span>
                      )}
                    </div>
                  ) : null}
                  {!hasNoFactorProduct ? (
                    <div className="w-100">
                      <label>پرداخت شده</label>
                      {orders_detail.amount === '-' ? (
                        ''
                      ) : (
                        <Uniter className="orders-toman-price" unit="تومان">
                          {orders_detail.payable_amount}
                        </Uniter>
                      )}
                    </div>
                  ) : null}
                  {hasNoFactorProduct && orders_detail.credit_amount ? (
                    <div className="w-100">
                      <label>جمع کل سفارش</label>
                      {orders_detail.amount === '-' ? (
                        ''
                      ) : (
                        <Uniter className="orders-toman-price" unit="تومان">
                          {orders_detail.payable_amount + orders_detail.credit_amount}
                        </Uniter>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>

              <h5 className="orders-detail-purchased-header">
                {!hasNoFactorProduct ? 'محصولات خریداری شده' : 'محصولات'}
              </h5>
              {orders_detail?.order_lines?.map((order_line, i) => (
                <div key={i} className="factors-item page-factor-factors-item">
                  {hasNoFactorProduct ? (
                    <div className="no-factor-product-item">
                      <img
                        alt="no-factor-product-order-line"
                        className="no-factor-product-order-line"
                        src={NoFactorProductImg}
                      />
                    </div>
                  ) : null}
                  <div key={i} className="orders-detail-products-box">
                    <div className="w-100">
                      <div>
                        <div className="w-100 " style={{ fontWeight: 'bold' }}>
                          <span> {order_line.product.name} </span>
                        </div>
                      </div>
                      {order_line.image === '' ? (
                        ''
                      ) : (
                        <img
                          alt={i}
                          className="order-img"
                          loading="lazy"
                          src={test ? order_line.image : BaseURL + order_line.image}
                        />
                      )}
                    </div>
                    <hr />
                    <div className="w-100">
                      <label>تعداد</label>
                      <span>
                        {order_line.quantity} {order_line.unit}
                      </span>
                    </div>
                    {order_line.items_quantity > 1 ? (
                      <div className="w-100">
                        <label>تعداد در {order_line.unit}</label>
                        <span>
                          {order_line.items_quantity} {order_line.items_unit}
                        </span>
                      </div>
                    ) : null}
                    <hr />
                    <div className="w-100">
                      <label>قیمت واحد</label>
                      <Uniter className="orders-toman-price" unit="تومان">
                        {order_line.price}
                      </Uniter>
                    </div>
                    <div className="w-100">
                      <label>جمع کل</label>
                      <Uniter className="orders-toman-price" unit="تومان">
                        {order_line.price * order_line.quantity}
                      </Uniter>
                    </div>
                    <div className="w-100">
                      <label>تخفیف</label>
                      <Uniter className="orders-toman-price" unit="تومان">
                        {order_line.discount_amount * order_line.quantity}
                      </Uniter>
                    </div>
                    <div className="w-100">
                      <label>قابل پرداخت</label>
                      <Uniter className="orders-toman-price" unit="تومان">
                        {order_line.amount * order_line.quantity}
                      </Uniter>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Page>
    );
  }
}
